export const columnProps = {
  editable: true,
  sortable: true,
  filterable: true,
};

export const columnHeader = [
  {
    key: 'source', name: 'Source', ...columnProps, editable: false, width: 140,
  },
  {
    key: 'order_id', name: 'Order ID', ...columnProps, editable: false,
  },
  {
    key: 'reference', name: 'Transacted Id', ...columnProps, editable: false, width: 160,
  },
  {
    key: 'credits', name: 'Credits', ...columnProps, editable: false,
  },
  {
    key: 'date', name: 'Created On', ...columnProps, editable: false,
  },
  {
    key: 'use_case', name: 'Use Case', ...columnProps, editable: false, width: 160,
  },
  {
    key: 'reason', name: 'Reason', ...columnProps, editable: false,
  },
  {
    key: 'comment', name: 'Comment', ...columnProps, editable: false,
  }
];
